import { createContext, useContext, useEffect, type PropsWithChildren } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { AuthenticatedUser } from '@24talk/shared';
import { clearSession, loadSession } from './session';

const AuthContext = createContext<{ user?: AuthenticatedUser; loading: boolean; error?: Error }>({
  loading: true,
});

export function AuthProvider({ children }: PropsWithChildren) {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => loadSession(signal),
    retry: false,
  });
  const signedOut = query.data?.user === null;
  useEffect(() => {
    if (signedOut) void clearSession(client);
  }, [client, signedOut]);
  return (
    <AuthContext.Provider
      value={{
        ...(query.data?.user ? { user: query.data.user } : {}),
        loading: query.isLoading,
        ...(query.error ? { error: query.error } : {}),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
